import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.base_url,
  }),
  endpoints: (builder) => ({
    signinUser: builder.mutation({
      query: (userData) => {
        return {
          url: "/sign-in",
          method: "post",
          body: userData,
        };
      },
    }),

    verifyUser: builder.mutation({
      query: (data) => {
        return {
          url: "/verify-email",
          method: "post",
          body: data,
        };
      },
    }),
    forgotPassword: builder.mutation({
      query: (email) => {
        return {
          url: "/forgot-password",
          method: "post",
          body: email,
        };
      },
    }),
    resetPassword: builder.mutation({
      query: (userData) => {
        return {
          url: "/reset-password",
          method: "post",
          body: userData,
        };
      },
    }),
    generateOtp: builder.mutation({
      query: (data) => {
        return {
          url: "/generate-otp",
          method: "post",
          body: data,
        };
      },
    }),
    getBanner: builder.query({
      query: () => "/banner",
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSigninUserMutation, useVerifyUserMutation, useForgotPasswordMutation, useResetPasswordMutation, useGenerateOtpMutation, useGetBannerQuery } = authApi;
